import { Component, OnInit, ɵConsole ,Input } from '@angular/core';

@Component({
  selector: 'app-resume-credit',
  templateUrl: './resume-credit.component.html',
  styleUrls: ['./resume-credit.component.sass']
})
export class ResumeCreditComponent implements OnInit {
  @Input() infoAfiliation;
  @Input() typeCard;
  @Input() affiliate;
  @Input() screen;
  constructor() { }

  ngOnInit() {
  }

}
